import { render, staticRenderFns } from "./LevelOutcomes.vue?vue&type=template&id=20927664&scoped=true"
import script from "./LevelOutcomes.vue?vue&type=script&lang=js"
export * from "./LevelOutcomes.vue?vue&type=script&lang=js"
import style0 from "./LevelOutcomes.vue?vue&type=style&index=0&id=20927664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20927664",
  null
  
)

export default component.exports